export default [
  {
    path: 'confirmed-scientific-topic-protocol',
    name: 'confirmed-scientific-topic-protocol',
    component: () => import('@/views/pages/confirmed-scientific-topic-protocol/Index.vue'),
    meta: {
      pageTitle: 'Scientific topic protocols',
      breadcrumb: [
        {
          text: 'Scientific topic protocols',
          active: true,
        },
      ],
      resource: 'ScientificTopicProtocol',
      action: 'manage',
    },
  },
]
